<template>
  <ejs-schedule
    id="Schedule"
    :selectedDate="selectedDate"
    :eventSettings="eventSettings"
    :popupOpen="onPopupOpen"
    :readonly="true"
    height="750px"
    class="p-events-schedule"
  >
    <e-views>
      <e-view option="Day"></e-view>
      <e-view option="Week"></e-view>
      <e-view option="Month"></e-view>
      <e-view option="TimelineDay"></e-view>
      <e-view option="TimelineWeek"></e-view>
      <e-view option="TimelineMonth"></e-view>
      <e-view option="Agenda"></e-view>
    </e-views>
  </ejs-schedule>
</template>


<script>
import Vue from 'vue'

import { mapGetters } from 'vuex'

import { SchedulePlugin, Day, Week, Month, TimelineMonth, TimelineViews, Agenda } from '@syncfusion/ej2-vue-schedule'
Vue.use(SchedulePlugin)

export default {
  provide: {
    schedule: [Day, Week, Month, TimelineViews, TimelineMonth, Agenda]
  },


  data () {
    return {
      selectedDate: new Date()
    }
  },


  computed: {
    ...mapGetters('event', ['eventsByProject']),
    ...mapGetters('project', ['currentProjectId']),

    eventSettings () {
      return {
        dataSource: this.eventsByProject(this.currentProjectId).map(event => {
          return {
            Id: event.id,
            Subject: event.title,
            StartTime: event.start,
            EndTime: event.stop,
            IsAllDay: event.allDay,
            RecurrenceID: event.id,
            RecurrenceRule: event.rRule,
            IsReadonly: true
          }
        })
      }
    }
  },


  methods: {
    onPopupOpen (args) {
      if (args.type === 'Editor') {
        args.cancel = true
      }
    }
  }
}
</script>
